import { render, staticRenderFns } from "./PreviewMedia.vue?vue&type=template&id=15977ac9&"
import script from "./PreviewMedia.vue?vue&type=script&lang=js&"
export * from "./PreviewMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports